import React from "react";
import HeaderNav from "@/components/HeaderNav";
import Footer from "@/components/Footer";
import ResaleShowcase from "@/components/ResaleShowcase";

export default function Shop() {
  return (
    <div className="min-h-screen bg-background" data-testid="shop-page">
      <HeaderNav />
      <div className="relative overflow-hidden tv-hero-dark py-14 lg:py-20">
        <div className="absolute inset-0 tv-hero-dark-grid opacity-70 pointer-events-none" />
        <div
          className="absolute -right-24 -top-16 select-none pointer-events-none"
          aria-hidden
        >
          <img src="/tech-value-logo.png" alt="" className="w-[420px] h-auto opacity-[0.10]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <span className="tv-chip-white mb-4">Tech Value · Shop</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
            Premium <span className="bg-gradient-to-r from-sky-300 to-primary bg-clip-text text-transparent">refurbished</span> phones.
          </h1>
          <p className="mt-3 text-slate-300 text-lg max-w-2xl">
            Certified, sanitised, and warranty-backed — pick a device, chat with us on WhatsApp, walk in or get it delivered.
          </p>
        </div>
      </div>
      <ResaleShowcase />
      <Footer />
    </div>
  );
}
